import * as prismic from '@prismicio/client';

export const repositoryName = 'rushservices';

export const client = prismic.createClient(repositoryName);
